import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import Sheet from 'components/utils/Sheet'
import { FullTrip } from 'tripPlanner/types/common'
import { daysUntilDate } from 'lib/datetime/dateUtils'
import Plural from 'components/utils/Formatters/Plural'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import StatusLabel from 'LuxKit/Label/StatusLabel'
import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import BodyTextBlock from '../../../LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  trip: FullTrip
}
function TripLandingPageHeader(props: Props) {
  const { trip } = props
  const daysUntilNextTrip = trip.startDate ? daysUntilDate(trip.startDate.toDate()) : null

  const firstDestination = trip.destinationsGeo?.[0]
  const firstDestinationName = firstDestination
    ? `${firstDestination.shortName}, ${firstDestination.countryCode}`
    : ''

  const numberOfAdults = trip.travellerRooms?.[0]?.adults
  const numberOfChildren = trip.travellerRooms?.[0]?.childAges?.length

  return (
    <Sheet
      paletteType="inverse"
      style={{ position: 'relative' }}
    >
      <Group direction="vertical" gap={16}>
        <Group direction="horizontal" gap={8} verticalAlign="center">

          {!!daysUntilNextTrip && daysUntilNextTrip > 0 && (
            <>
              <StatusLabel
                variant="confirmation"
              >
                <Plural count={daysUntilNextTrip} singular="Day" withCount /> to go
              </StatusLabel>
              <BodyText variant="medium">
                until your next trip
              </BodyText>
            </>
          )}
        </Group>
        <HeadingTextBlock variant="heading1">
          <Heading variant="heading1">
            {trip.name}
          </Heading>
        </HeadingTextBlock>
        <Group direction="horizontal" gap="4 16" wrap="wrap">
          {firstDestinationName && (
            <BodyTextBlock variant="large" startIcon={<LineMapMarkerIcon />}>
              {firstDestinationName}
            </BodyTextBlock>
          )}
          {trip.startDate && trip.endDate && (
            <BodyTextBlock variant="large" startIcon={<LineCalendarIcon />}>
              <FormatDateTimeRange startValue={trip.startDate} endValue={trip.endDate} format="short-day-name-day-month-year" />
            </BodyTextBlock>
          )}
          {!!numberOfAdults && (
            <BodyTextBlock variant="large" startIcon={<LineUsersAltIcon />}>
              {numberOfAdults} adults {numberOfChildren && numberOfChildren > 0 ? `, ${numberOfChildren} children` : ''}
            </BodyTextBlock>
          )}
        </Group>
        <Group direction="horizontal" gap={16} verticalAlign="center">
          <TextButton
            kind="primary"
            size="large"
            shape="round"
            to={`/trip-planner/trip/${trip.id}/itinerary`}
          >
            View trip plan
          </TextButton>
          <TextButton
            kind="secondary"
            size="large"
            startIcon={<SolidSparklesIcon />}
            shape="round"
            to="/trip-planner/generate-trip"
          >
            Plan new trip
          </TextButton>
        </Group>
      </Group>
    </Sheet>
  )
}

export default TripLandingPageHeader
